import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { icons } from 'utils/constants';
import Button from 'components/form/Button';
import { getDataFromLocalStorage, objectToFormData } from 'utils/helpers';
import Card from 'components/Layout/Card';
import EnterOTP from './EnterOTP';
import ConfirmVerification from './ConfirmVerification';
import './VerifyEmail.scss';
import { useDispatch } from 'react-redux';
import { handelSendOTP } from 'store/slices';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [verificationMethod, setVerificationMethod] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [otpSend, setOtpSend] = useState(false);

  useEffect(() => {
    let { registration_email_otp_status, email_id } = getDataFromLocalStorage();
    if (registration_email_otp_status === '1') {
      setIsVerified(true);
    }
    setUserEmail(email_id);
  }, []);

  const handleVerification = (method) => {
    setVerificationMethod(method);
  };

  const [otpLoader, setOtpLoader] = useState(false);
  const [isOTPSent, setIsOTPSent] = useState(true);
  const [counter, setCounter] = useState(600);
  const dispatch = useDispatch();

  const hadnleOtpSend = async () => {
    setOtpLoader(true);
    const response = await dispatch(
      handelSendOTP(objectToFormData({ email: userEmail }))
    );
    if (response?.status === 200) {
      setOtpSend(true);
      setIsOTPSent(true);
      setCounter(600);
    }
    setOtpLoader(false);
  };

  return (
    <Card>
      {/* Top Title Bar */}
      <div className="d-flex align-items-center border-bottom cp-16">
        <button
          className="btn btn-link text-decoration-none p-0 me-3"
          onClick={() => navigate(-1)}
        >
          <img
            src={icons.leftArrow}
            alt="Back"
            className="me-2"
            style={{ height: '20px' }}
          />
        </button>
        <h6 className="text-16-400-20">Email ID Verification</h6>
      </div>

      <div style={{ minHeight: '65vh' }}>
        <div className="d-flex align-items-center justify-content-center cmt-71">
          {isVerified ? (
            <div>
              <div className=" d-flex flex-column align-items-center ">
                <div className="cmb-27">
                  <img src={icons?.abstractDone} alt="logo" />
                </div>
                <div className="color-a35b text-24-700-30 cmb-27">
                  Email is already verified.
                </div>
              </div>
            </div>
          ) : otpSend ? (
            <EnterOTP
              setIsOTPSent={setIsOTPSent}
              isOTPSent={isOTPSent}
              counter={counter}
              setCounter={setCounter}
              userEmail={userEmail}
            />
          ) : verificationMethod ? (
            <>
              <ConfirmVerification
                setVerificationMethod={setVerificationMethod}
                verificationMethod={verificationMethod}
                hadnleOtpSend={hadnleOtpSend}
                userEmail={userEmail}
                otpLoader={otpLoader}
              />
            </>
          ) : (
            <div style={{ maxWidth: '800px' }}>
              {/* Centered Content */}
              <div className="text-center">
                <p className="text-24-500-30">Email Verification Required</p>

                <p className="text-muted cmb-24 cmt-24 text-16-400-28 color-black-olive">
                  To proceed, please verify your email address using one of the
                  following methods.
                  <br />
                  You can either receive a verification{' '}
                  <strong>link or an OTP</strong> to your registered email
                  address.
                </p>
              </div>

              {/* Action Buttons */}
              <div className="d-flex gap-3 justify-content-center w-75 m-auto">
                <div className="flex-fill">
                  <Button
                    text="Verify Via OTP"
                    btnStyle="primary-dark"
                    className="h-40 w-25"
                    onClick={() => handleVerification('otp')}
                  />
                </div>
                <div className="flex-fill">
                  <Button
                    text="Verify Via Link"
                    btnStyle="primary-light-outline"
                    className="h-40 w-25"
                    onClick={() => handleVerification('link')}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default VerifyEmail;
